import React from 'react';
import { Button } from '@chakra-ui/react';
import styled from '@emotion/styled';

const ButtonStyled = styled(Button)`
  width: 100%;
  margin-top: 16px;
  background: ${({ theme }) => theme.colors.malachite[2]};
  color: ${({ theme }) => theme.colors.white};
  padding: 24px 48px;
  border-radius: 24px;
  border: 1px solid ${({ theme }) => theme.colors.malachite[2]};
  align-self: flex-end;
  &:hover {
    background: ${({ theme }) => theme.colors.malachite[2]};
    border: 1px solid ${({ theme }) => theme.colors.graphite[1]};
  }
  &:active {
    background: ${({ theme }) => theme.colors.malachite[1]};
    border: 1px solid ${({ theme }) => theme.colors.malachite[1]};
  }
`;

interface Props {
  submitting: boolean;
}

export const SubmitButton: React.FC<Props> = ({ submitting }) => (
  <ButtonStyled type="submit" disabled={submitting}>
    Отправить
  </ButtonStyled>
);
